<template>
  <AccountPanel v-if="offer" class="offer-page" :title="'Oferta nr ' + offer.id + ' z dnia ' + offer.added.substr(0,10)">
    <p class="offer-buttons">
      <button @click="openPdf()"  type="button" class="btn btn-success">PDF</button>
      <button @click="addToCart()"  type="button" class="btn btn-info">Wstaw do koszyka</button>
    </p>
    <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col">Nazwa</th>
        <th scope="col">Ilość</th>
        <th scope="col">Netto jedn.</th>
        <th scope="col">Vat</th>
        <th scope="col">Brutto jedn.</th>
        <th scope="col">Brutto</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="position in offer.positions">
          <td style="width: 100px"><img :src="position.product.image" class="img-fluid" /></td>
          <td>
              <router-link :to="{ name: 'productPage', params:{id: position.product.id, slug: 'item'}}">
                {{position.product.name}}
              </router-link>
          </td>
          <td>{{position.quantity}}</td>
          <td>{{priceToString(position.net, 'PLN')}}</td>
          <td>{{priceToString(position.tax, 'PLN')}}</td>
          <td>{{priceToString(position.gross, 'PLN')}}</td>
          <td>{{priceToString(position.gross * position.quantity, 'PLN')}}</td>
        </tr>

        <tr class="bg-info">
          <td colspan="5"></td>
          <td>Razem Netto</td>
          <th>{{priceToString(offer.total_net, 'PLN')}}</th>
        </tr>
        <tr class="bg-info">
          <td colspan="5"></td>
          <td>Razem VAT</td>
          <th>{{priceToString(offer.total_tax, 'PLN')}}</th>
        </tr>
        <tr class="bg-info">
          <td colspan="5"></td>
          <td>Razem Brutto</td>
          <th>{{priceToString(offer.total_gross, 'PLN')}}</th>
        </tr>
      </tbody>
    </table>


  </AccountPanel>
</template>

<script>

  import { mapState } from 'vuex';
  import CalculatePrice from 'redbay-b2b-products/src/product/CalculatePrice'
  import AccountPanel from 'redbay-b2b-account/src/account/AccountPanel.vue'
  import pdfMake from "pdfmake/build/pdfmake"
  import pdfFonts from "pdfmake/build/vfs_fonts"
  import htmlspecialchars_decode from "locutus/php/strings/htmlspecialchars_decode"

  export default {
    data () {
      return {
        offer: null,
        group: '',
        attributes: []
      }
    },
    components: {
        AccountPanel
    },
    computed: {
      ...mapState({
        user: state => state.user.authorizedUser,
        userSettings:  state => state.user.userSettings,
        userPrices: state => state.user.userPrices,
      }),
    },
    props: ['offerId'],
    methods: {
      ...CalculatePrice(),

      positionsArray() {
        return this.offer.positions.map(p => {
          let result = [];
          result.push(p.product.name);
          result.push(p.quantity);
          result.push(this.priceToString(p.net, 'PLN'));
          result.push(this.priceToString(p.tax, 'PLN'));
          result.push(this.priceToString(p.gross, 'PLN'));
          result.push(this.priceToString(p.gross * p.quantity, 'PLN'));
          return result;
        })
      },

      companyName() {

        let text = htmlspecialchars_decode(htmlspecialchars_decode(this.user.company.fullname)) + "\n";
        text += this.user.company.street + " " + this.user.company.flat + "\n";
        text += this.user.company.postcode + " " + this.user.company.city + "\n";
        text += "NIP: " + this.user.company.company.nip + "\n";
        return text;
      },

      summaryText() {
        let text = "RAZEM\n";
        text += "Netto:\t" + this.priceToString(this.offer.total_net, 'PLN') + "\n";
        text += "VAT:\t\t" + this.priceToString(this.offer.total_tax, 'PLN') + "\n";
        text += "Brutto:\t" + this.priceToString(this.offer.total_gross, 'PLN') + "\n";

        return text
      },

      async addToCart() {
        await this.$store.dispatch('offer/addOfferToBasket', this.offerId);
        this.$router.replace({ name: 'cart'});
      },

      openPdf: function () {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        let docDefinition = {
          content: [
            {text: "Oferta nr " + this.offerId + " z dnia " + this.offer.added.substr(0, 10), fontSize: 15, bold: true, margin: [ 5, 2, 10, 20 ]},
            {
              columns: [
                {
                  width: '300',
                  text: this.companyName(),
                  margin: [ 5, 2, 10, 20 ]
                },
                {
                  width: '*',
                  text: ''
                }
              ]
            },
            {
              table: {
                headerRows: 1,
                widths: [ '*', 40, 80, 80, 80, 80 ],
                body: [
                  ['Nazwa', 'Ilość', 'Netto jedn.', 'VAT', 'Brutto jedn.', 'Brutto'],
                  ...this.positionsArray()
                ]
              }
            },
            {text: this.summaryText(), fontSize: 12, italic: true, margin: [ 320, 20, 10, 10 ]},
            {text: "Oferta jest ważna do dnia " + this.offer.expire.substr(0, 10), fontSize: 12, italic: true, margin: [ 20, 2, 10, 10 ]},
          ]
        };

        pdfMake.createPdf(docDefinition).open();


      }

    },
    async beforeMount() {
      this.group = this.userSettings['USER_GROUP'] ? this.userSettings['USER_GROUP'] : 0;
      this.attributes = this.$config.get('searchPage.visibleAttributes');
      this.offer = await this.$store.dispatch('offer/offer',
        {id: this.offerId,  attributes: this.attributes, prices: this.userPrices, group: this.group});
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-offer/src/OfferPage.vue